import { AuthProvider, useAuth } from '@/context/AuthContext';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import DailyReport from '@/pages/DailyReport';
import Attendance from '@/pages/Attendance';
import Leaves from '@/pages/Leaves';
import Leaderboard from '@/pages/Leaderboard';
import JobOpenings from '@/pages/JobOpenings';
import Interviews from '@/pages/Interviews';
import Team from '@/pages/Team';
import OfflineLog from '@/pages/OfflineLog';
import Lineups from '@/pages/Lineups';
import LineupProfile from '@/pages/LineupProfile';
import CallLogging from '@/pages/CallLogging';

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-background text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="report" element={<DailyReport />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="leaves" element={<Leaves />} />
              <Route path="leaderboard" element={<Leaderboard />} />
              <Route path="jobs" element={<JobOpenings />} />
              <Route path="candidates" element={<Navigate to="/lineups" replace />} />
              <Route path="lineups" element={<Lineups />} />
              <Route path="lineups/:id" element={<LineupProfile />} />
              <Route path="call-logging" element={<CallLogging />} />
              <Route path="interviews" element={<Interviews />} />
              <Route path="team" element={<Protected roles={['admin']}><Team /></Protected>} />
              <Route path="offline-log" element={<Protected roles={['admin']}><OfflineLog /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
